<div class="container-content">
    <div *ngIf="alignment === 'horizontal'" class="divider-horizontal" [ngClass]="{
            'left': position === 'left',
            'right': position === 'right',
            'center': position === 'center'
        }" [ngStyle]="{width: size}"></div>
    <div *ngIf="alignment === 'vertical'" class="divider-vertical" [ngClass]="{
            'top': position === 'top',
            'bottom': position === 'bottom',
            'center': position === 'center'
        }" [ngStyle]="{height: size}"></div>
</div>